import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import DataTable from 'react-data-table-component';
import { BiTrash, BiXCircle } from "react-icons/bi";
import { SearchIcon } from '@primer/octicons-react';
import UserPickerDialog from './UserPickerDialog';
import DeleteConfirmDialog from './DeleteConfirmDialog';
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import { UserContext } from "../UserContext";
import { translateAPIError } from '../utils/apiUtils';
import { hasAnyPerm } from '../utils/uiUtils';
import { formatDate } from '../utils/timeUtils';
import classes from './AdminPages.module.css';


const ObjFlagAdmin = (props) => {

  const { t } = useTranslation(["common"]);
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    objType: null,
    flag: null,
    value: null,
    userId: null,
    username: null
  });

  const [errMsg,          setErrMsg]          = useState('');
  const [notFoundMsg,     setNotFoundMsg]     = useState('');

/*
  const [searchTerms,     setSearchTerms]     = useState();
*/

  const [objTypeList,     setObjTypeList]     = useState([]);
  const [flagList,        setFlagList]        = useState([]);
  const [valueList,       setValueList]       = useState([]);

/*
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     15,
                                        currPage:    1});
*/



  // ----- Data Table stuff -----

  const [objList,   setObjList]   = useState([]);
  const [,          setLoading]   = useState(false);
  const [totalRows, setTotalRows] = useState();
  const [perPage,   setPerPage]   = useState(15);
  const [currPage,  setCurrPage]  = useState(1);
  const [sortCol,   setSortCol]   = useState(null);
  const [sortDir,   setSortDir]   = useState(null);

  const customStyles = {
    rows: {
      style: {
        minHeight: '25px', // override the row height
        fontSize: '11px',
      },
    },
    headCells: {
      style: {
        paddingLeft: '8px', // override the cell padding for head cells
        paddingRight: '8px',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px', // override the cell padding for data cells
        paddingRight: '8px',
      },
    },
  };

  const columns = [
    {
      name: t("I18N_Obj_type"),
      selector: row => row.objType,
      sortable: true,
      sortField: 'objType'
    },
    {
      name: t("I18N_Obj_id"),
      selector: row => (row.objId && (row.objId != null) ? row.objId : '--'),
      sortable: true,
      sortField: 'objId'
    },
    {
      name: t("I18N_Obj_code"),
      selector: row => (row.objCode && (row.objCode != null) ? row.objCode : '--'),
      sortable: true,
      sortField: 'objCode'
    },
    {
      name: t("I18N_Username"),
      selector: row => (row.username && (row.username != null) ? row.username : t("I18N_All_users")),
      wrap: true,
      sortable: true,
      sortField: 'username'
    },
    {
      name: t("I18N_Flag_name"),
      selector: row => row.name,
      sortable: true,
      sortField: 'flagName'
    },
    {
      name: t("I18N_Flag_value"),
      selector: row => row.value,
      sortable: true,
      sortField: 'flagValue'
    },
    {
      name: t("I18N_Created_by"),
      selector: row => row.creatorUsername,
      wrap: true,
      sortable: true,
      sortField: 'creatorUsername'
    },
    {
      name: t("I18N_Time_created"),
      selector: row => formatDate(row.timeCreated),
      sortable: true,
      sortField: 'timeCreated'
    },
    {
      name: '',
      selector: row => row.id,
      grow: 0.5,
      cell: row => (
        <OverlayTrigger overlay={<Tooltip id="tooltip-delete-dp" style={{fontSize:'11px'}}>{t("I18N_TIP_Delete_flag")}</Tooltip>}>
          <span style={{cursor:'pointer', color:'SteelBlue'}}
                onClick={() => handleObjDelete(row)}><BiTrash size={16} />
          </span>
        </OverlayTrigger>
      )
    }
  ];

  const handlePageChange = currPage => {
    setCurrPage(currPage);
/*
    setPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    currPage});
*/

    fetchObjs(/*searchTerms, */sortCol, sortDir, perPage, currPage);
  };


  const handlePerRowsChange = async (newPerPage) => {

    setPerPage(newPerPage);
/*
    setPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     newPerPage,
                          currPage:    currPage});
*/

    fetchObjs(/*searchTerms, */sortCol, sortDir, newPerPage, 1);
  };


  const handleSort = (column, sortDir) => {

    // instead of setTimeout this is where you would handle your API call.
    setSortCol (column.sortField);
    setSortDir (sortDir);

/*
    setPageState({searchTerms: searchTerms,
                          sortCol:     column.sortField,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});
*/

    fetchObjs(/*searchTerms, */column.sortField, sortDir, perPage, 1);
  };

  const paginationComponentOptions={
          rowsPerPageText: t("I18N_Rows_per_page"),
          rangeSeparatorText: t("I18N_Pagination_page_of_total"),
          noRowsPerPage: false,
          selectAllRowsItem: false,
          selectAllRowsItemText: 'All'
        };

  // ----- END - Data Table stuff -----

  // ----- User Picker Dialog -----

  const [showUserPickerDialog, setShowUserPickerDialog] = useState(false);

  function handleUserSelect(user) {

    let tmp = {};

    tmp.userId   = user.id;
    tmp.username = user.username;

    setObjAttrs({ ...objAttrs, ...tmp })

    setShowUserPickerDialog(false);
  }

  const handleUserPicker = (e) => {
    setShowUserPickerDialog(true);
  }

  function handleUserPickerClose() {
    setShowUserPickerDialog(false);
  } 


  // ----- END - User Picker Dialog -----

  // ----- Delete Confirmation Dialog -----

  const [deleteTarget,            setDeleteTarget]            = useState();
  const [showDeleteConfirmDialog, setShowDeleteConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('');

  function handleObjDelete(obj) {
    setDeleteTarget(obj);
    setShowDeleteConfirmDialog(true);
  }

  function handleObjDeleteCancel() {
    setDeleteTarget(null);
    setErrMsgDeleteConfirm('');
    setShowDeleteConfirmDialog(false);
  }

  // ----- END - Delete Confirmation Dialog -----

  // ----- General Initialization -----

  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["PlatformAdminWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    fetchObjFlagDefs();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // ----- Backend Data Processing -----

  const fetchObjFlagDefs = async () => {

    try {
      const res = await axiosAuth_PLATFORM_API.get("business-configs?name=OBJ_FLAGS");

      if (!res.data || (res.data.length === 0)) {
        setErrMsg("I18N_No_search_result");
      } else {
        setObjTypeList(res.data[0].config.objTypes);
        setErrMsg('');
      }

    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
         setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const fetchObjs = async (/*searchTerms, */sortCol, sortDir, perPage, currPage) => {

    try {
      setLoading(true);

      const res = await axiosAuth_PLATFORM_API.get("obj-flags?" +
                                                    ((objAttrs.objType && (objAttrs.objType !== null)) ? ("&objType="     + objAttrs.objType.name)                 : '') +
                                                    ((objAttrs.flag    && (objAttrs.flag    !== null)) ? ("&flagName="    + objAttrs.flag.name)                    : '') +
                                                    ((objAttrs.value   && (objAttrs.value   !== null)) ? ("&flagValue="   + objAttrs.value)                        : '') +
                                                    ((objAttrs.userId  && (objAttrs.userId  !== null)) ? ("&userId="      + objAttrs.userId)                       : '') +
                                                  //((searchTerms      && (searchTerms      !== null)) ? ("&searchTerms=" + encodeURIComponent(searchTerms))       : '') +
                                                    ((sortCol          && (sortCol          !== null)) ? ("&sortColumn="  + sortCol + "&sortDirection=" + sortDir) : '') +
                                                    ((perPage          && (perPage          !== null)) ? ("&limit="       + perPage)                               : '') +
                                                    ((currPage         && (currPage         !== null)) ? ("&offset="      + (currPage - 1) * perPage)              : ''));

      if (res.data.data.length === 0) {
        setNotFoundMsg("I18N_No_search_result");
      } else {
        setNotFoundMsg('');
      }

      setObjList(res.data.data);

      setTotalRows(res.data.total);
      setLoading(false);
      setErrMsg('');
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };

  function handleObjDeleteSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.delete("obj-flags/" + deleteTarget.id);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsgDeleteConfirm('');
          setShowDeleteConfirmDialog(false);

          // This will also cause a reload of the list.  Change to page 1 because in case deleting
          // the last item on the last page, refreshing the old last page will cause error.
          handlePageChange(1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsgDeleteConfirm(t(translateAPIError(error)));
        }
      }
    });
  }


  // ----- END Delete stuff -----


/*
  const onSearchInputChange = (e) => {
    setSearchTerms(e.target.value);
  }
*/

  const handleSearchSubmit = (e) => {
    e.preventDefault();

    setCurrPage(1); // Reset to page 1 for a fresh search
/*
    setPageState({searchTerms: searchTerms,
                          sortCol:     sortCol,
                          sortDir:     sortDir,
                          perPage:     perPage,
                          currPage:    1});
*/

    fetchObjs(/*searchTerms, */sortCol, sortDir, perPage, 1);
  }

  const onObjTypeSelect = (index, event) => {
    let tmp = {};
    tmp.objType = objTypeList[index];
    tmp.flag = null;
    tmp.value = null;

    setObjAttrs({ ...objAttrs, ...tmp });
    setFlagList(objTypeList[index].flags);
    setValueList([]);
  };

  const onFlagSelect = (index, event) => {
    let tmp = {};
    tmp.flag = flagList[index];
    tmp.value = null;

    setObjAttrs({ ...objAttrs, ...tmp });
    setValueList(flagList[index].values ? flagList[index].values : []);
  };

  const onValueSelect = (value, event) => {
    setObjAttrs({ ...objAttrs, 'value' : value });
  };

  const onInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  } 

  const handleClearObjType = () => {
    let tmp = {};
    tmp.objType = null;
    tmp.flag = null;
    tmp.value = null;

    setObjAttrs({ ...objAttrs, ...tmp });

    setFlagList([]);
    setValueList([]);
  }

  const handleClearFlag = () => {
    let tmp = {};
    tmp.flag = null;
    tmp.value = null;

    setObjAttrs({ ...objAttrs, ...tmp });

    setValueList([]);
  }

  const handleClearValue = () => {
    setObjAttrs({ ...objAttrs, 'value' : null });
  }


  return (
    <>
      <Card className='aaa' style={{border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)', padding:'20px 40px 20px 40px', maxWidth:'2500px', height:'850px', width:'100%'}}>
        <div style={{ display: 'flex' }}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_ObjFlag_Management")}
          </span>
        </div>

        <div style={{ display: 'flex', marginTop: '20px' }}>
          <Container>

            <Row>
              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
              <span style={{ marginBottom: '5px', fontSize:'15px' }}>{t("I18N_Search_criteria")}</span>
            </Row>

            <Row className={classes.admin_pages__field_label}>
              <Col>{t("I18N_Obj_type")}:</Col>
              <Col>{t("I18N_Flag_name")}:</Col>
              <Col>{t("I18N_Flag_value")}:</Col>
              <Col>{t("I18N_Username")}:</Col>
            </Row>

            <Row className={classes.admin_pages__field_value} style={{ marginTop: '5px' }}>
              <Col style={{ display: 'flex'}}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={objAttrs.objType ? objAttrs.objType.name : t("I18N_DROPDOWN_PROMPT") }
                  style={{ width: '150px' }}
                  onSelect={onObjTypeSelect}>
                  {objTypeList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={index} className={classes.dropdown_item_wrap}>
                        { item.name }
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <span onClick={handleClearObjType} style={{ marginLeft:'5px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiXCircle size={14} />
                </span>
              </Col>

              <Col style={{ display: 'flex'}}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  disabled={!(objAttrs.objType && objAttrs.objType.name)}
                  title={objAttrs.flag ? objAttrs.flag.name : t("I18N_DROPDOWN_PROMPT") }
                  style={{ width: '150px' }}
                  onSelect={onFlagSelect}>
                  {flagList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={index} className={classes.dropdown_item_wrap}>
                        { item.name }
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <span onClick={handleClearFlag} style={{ marginLeft:'5px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiXCircle size={14} />
                </span>
              </Col>

              <Col style={{ display: 'flex'}}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  disabled={!valueList ||  valueList.length===0}
                  title={objAttrs.value ? objAttrs.value : t("I18N_DROPDOWN_PROMPT") }
                  style={{ width: '150px' }}
                  onSelect={onValueSelect}>
                  {valueList.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item} className={classes.dropdown_item_wrap}>
                        { item }
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
                <span onClick={handleClearValue} style={{ marginLeft:'5px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiXCircle size={14} />
                </span>
              </Col>

              <Col>
                <input className={classes.admin_pages__field_editable} name="username" value={objAttrs && objAttrs.username ? objAttrs.username : ''}
                       onChange={(e) => onInputChange(e)} />
                <span onClick={handleUserPicker} style={{ marginLeft:'10px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <SearchIcon size={14} />
                </span>
              </Col>
              
            </Row>

            <Row>
              <Col>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginTop: '20px' }}
                  onClick={handleSearchSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
                  {errMsg}
                </span>
              </Col>
            </Row>

            <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          </Container>

{/*
          <span style={{marginLeft:'auto', marginTop:'7px', color:'rgba(200,0,0)', fontSize:'12px'}}>
            {errMsg}
          </span>
          <div style={{ display: 'flex', marginLeft: '30px', marginRight: '0px', width: '250px', minWidth: '250px' }}>
            <span style={{ marginLeft: '20px', marginRight: '0px', width: '220px' }}>
              <Form onSubmit={handleSearchSubmit}>
                <Form.Group as={Row} >
                  <Col sm="9" style={{ marginRight: '5px' }}>
                    <Form.Control style={{ fontSize: '12px' }} type="text" name="searchTerm" value={searchTerms} onChange={(e) => onSearchInputChange(e)} placeholder={t("I18N_Search_terms")} />
                  </Col>
                  <Col sm="2" style={{ padding: '5px' }}>
                    <OverlayTrigger placement="left" overlay={<Tooltip id="tooltip-search" style={{fontSize:'11px'}}>{t("I18N_Search")}</Tooltip>}>
                      <span onClick={handleSearchSubmit} style={{ cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                        <SearchIcon size={18} />
                      </span>
                    </OverlayTrigger>
                  </Col>
                </Form.Group>
              </Form>
            </span>
          </div>
*/}
        </div>


        { (notFoundMsg && notFoundMsg !== '') ?
          <span className={classes.admin_pages__field_value} style={{marginTop:'20px'}}>
            {t(notFoundMsg)}
          </span>
        :
          <div style={{ overflowY:'auto', fontSize:'11px', marginTop:'10px' }}>

            { objList && objList.length > 0 ?
              <DataTable
                columns={columns}
                data={objList}
                customStyles={customStyles}
                fixedHeader
                fixedHeaderScrollHeight={'700px'}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationDefaultPage={currPage}
                paginationPerPage={perPage}
                paginationRowsPerPageOptions={[15,30,60]}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                onSort={handleSort}
                sortServer
                highlightOnHover
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent={t("I18N_No_search_result")}
              />
            : null
            }

          </div>
        }

        <UserPickerDialog
          show={showUserPickerDialog}
          handleObjSelect={handleUserSelect}
          onClose={handleUserPickerClose}
          type='FLOOR'
        />

        <DeleteConfirmDialog
          title={t("I18N_Biz_config_del_confirm")}
          show={showDeleteConfirmDialog}
          targetName={deleteTarget ? (deleteTarget.objType + ' / ' + deleteTarget.name + ' / ' + deleteTarget.username) : ''}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleObjDeleteCancel}
          onSubmit={handleObjDeleteSubmit}
        />


      </Card>
    </>
  );
}


export default ObjFlagAdmin;
